import React, { useState } from 'react';
import { 
  Users, 
  ScanSearch, 
  Star, 
  HeartPulse, 
  UserSquare, 
  LogOut, 
  Bell 
} from 'lucide-react';

// ✅ CONEXIÓN AL SISTEMA NERVIOSO CENTRAL (Rutas Absolutas)
import { useGlobal } from 'context/GlobalContext';

// IMPORTACIÓN DE VISTAS DEL MÓDULO
import PerfilMaestro from 'pages/maestro/PerfilMaestro';
import MiGrupo from 'pages/maestro/MiGrupo';
import BuscadorGlobal from 'pages/maestro/BuscadorGlobal';
import ConductaYPremios from 'pages/maestro/BitacoraConducta'; // Sincronizado con tu archivo anterior
import RadarSalud from 'pages/maestro/RadarSalud';

const MaestroModule = ({ alSalir }) => {
  // 1. Extraemos los datos globales para alimentar a todos los sub-componentes
  const { ninos, alertasAdmin } = useGlobal();
  
  const [tabActiva, setTabActiva] = useState('grupo');
  
  // Contador dinámico basado en las alertas activas en el sistema
  const [notificaciones] = useState(alertasAdmin.length);

  const menuNavegacion = [
    { id: 'grupo', titulo: 'Mi Grupo', icono: Users },
    { id: 'salud', titulo: 'Salud', icono: HeartPulse },
    { id: 'buscador', titulo: 'Buscador', icono: ScanSearch },
    { id: 'conducta', titulo: 'Conducta', icono: Star },
    { id: 'perfil', titulo: 'Perfil', icono: UserSquare }
  ];

  // 2. RENDERIZADO CON INYECCIÓN DE DATOS REALES
  const renderPantallaActiva = () => {
    // Props compartidas para mantener la reactividad en tiempo real
    const propsComunes = { ninos, alertasAdmin };

    switch (tabActiva) {
      case 'perfil': return <PerfilMaestro />;
      case 'grupo': return <MiGrupo {...propsComunes} />;
      case 'buscador': return <BuscadorGlobal {...propsComunes} />;
      case 'conducta': return <ConductaYPremios {...propsComunes} />;
      case 'salud': return <RadarSalud {...propsComunes} />;
      default: return <MiGrupo {...propsComunes} />;
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col font-sans">
      
      {/* HEADER DE CONTROL - FIJO */}
      <header className="bg-white px-6 py-4 flex items-center justify-between shadow-sm sticky top-0 z-50">
        <div className="flex flex-col text-left">
          <h1 className="text-xl font-black text-slate-900 italic tracking-tight leading-none uppercase">
            IgleKids
          </h1>
          <span className="text-[10px] font-black text-indigo-500 uppercase tracking-[0.2em] italic">
            Portal Maestro — Casa de Fe
          </span>
        </div>
        
        <div className="flex items-center gap-3">
          <button className="relative p-2 bg-slate-100 rounded-xl text-slate-500 hover:text-indigo-600 transition-all active:scale-90">
            <Bell size={18} />
            {notificaciones > 0 && (
              <span className="absolute -top-1 -right-1 w-5 h-5 bg-rose-500 text-white text-[9px] font-black flex items-center justify-center rounded-full border-2 border-white animate-pulse">
                {notificaciones}
              </span>
            )}
          </button>

          <button 
            onClick={alSalir}
            className="w-10 h-10 bg-slate-100 rounded-xl flex items-center justify-center text-slate-400 hover:bg-rose-50 hover:text-rose-500 transition-all active:scale-90"
          >
            <LogOut size={18} />
          </button>
        </div>
      </header>

      {/* CONTENIDO PRINCIPAL */}
      <main className="flex-1 w-full max-w-[1400px] mx-auto p-4 md:p-8 pb-32">
        <div className="animate-in fade-in slide-in-from-bottom-2 duration-500">
           {renderPantallaActiva()}
        </div>
      </main>

      {/* NAVEGACIÓN INFERIOR (TAB BAR GIGANTE PARA IPAD) */}
      <nav className="fixed bottom-0 w-full bg-white/80 backdrop-blur-xl border-t-2 border-slate-100 pb-safe z-50 shadow-[0_-10px_40px_rgba(0,0,0,0.05)]">
        <div className="max-w-2xl mx-auto flex justify-between items-center px-6 py-3">
          {menuNavegacion.map((item) => {
            const activo = tabActiva === item.id;
            const Icono = item.icono;
            
            return (
              <button
                key={item.id}
                onClick={() => setTabActiva(item.id)}
                className="flex flex-col items-center justify-center w-14 group relative"
              >
                {/* Indicador visual superior de pestaña activa */}
                <div className={`absolute -top-3 w-8 h-1 rounded-full transition-all duration-500 ${
                  activo ? 'bg-indigo-600 shadow-[0_0_10px_rgba(79,70,229,0.5)]' : 'bg-transparent'
                }`} />
                
                <div className={`flex items-center justify-center mb-1 transition-all duration-300 ${
                  activo ? 'text-indigo-600 scale-110' : 'text-slate-400 hover:text-slate-600'
                }`}>
                  {item.id === 'buscador' ? (
                    <div className={`p-2 rounded-xl transition-all ${activo ? 'bg-indigo-600 text-white shadow-xl rotate-12' : 'bg-slate-50'}`}>
                      <Icono size={22} strokeWidth={activo ? 3 : 2} />
                    </div>
                  ) : (
                    <Icono size={24} strokeWidth={activo ? 2.5 : 2} />
                  )}
                </div>
                
                <span className={`text-[8px] font-black uppercase tracking-widest transition-all ${
                  activo ? 'text-indigo-600 opacity-100' : 'text-slate-400 opacity-50'
                }`}>
                  {item.titulo}
                </span>
              </button>
            );
          })}
        </div>
      </nav>

    </div>
  );
};

export default MaestroModule;